export function modelSyncConfigV103(config = {}) {
  const value = config.model_sync_v103;
  return {
    provider: value?.provider || '',
    add_all_new: value?.add_all_new === true,
    strip_free_suffix: value?.strip_free_suffix === true,
    remove_unavailable: value?.remove_unavailable === true,
    add_free: value?.add_free === true,
    remove_paid:
      value?.remove_paid === undefined
        ? !value?.provider && value?.add_free === true
        : value.remove_paid === true,
  };
}

export function buildModelSyncSubmissionV103(config = {}, serverState) {
  const next = { ...config };
  delete next.model_sync_state_v103;
  // Echo only the server snapshot's version marker, never writable runtime status.
  if (
    Number.isSafeInteger(serverState?.last_success_at) &&
    serverState.last_success_at >= 0
  ) {
    next.model_sync_state_v103 = {
      last_success_at: serverState.last_success_at,
    };
  }
  const value = next.model_sync_v103;
  if (value !== undefined) {
    if (
      !value ||
      typeof value !== 'object' ||
      Array.isArray(value) ||
      [
        'remove_unavailable',
        'add_free',
        'remove_paid',
        'add_all_new',
        'strip_free_suffix',
      ].some(
        (key) => value[key] !== undefined && typeof value[key] !== 'boolean'
      )
    ) {
      throw new Error('model_sync_v103.invalid_config');
    }
    if (
      !['', 'openrouter', 'nvidia', 'zenmux'].includes(value.provider || '') ||
      (value.add_all_new && value.add_free)
    )
      throw new Error('model_sync_v103.invalid_config');
    next.model_sync_v103 = { ...value, ...modelSyncConfigV103(next) };
  }
  return next;
}

export function savedChannelIdV103(routeId, savedId) {
  if (!/^\d+$/.test(String(routeId))) return null;
  const id = Number(routeId);
  return Number.isSafeInteger(id) && id > 0 && id === Number(savedId)
    ? id
    : null;
}

export function modelSyncSnapshotV103(channel, routeId) {
  if (!channel || !savedChannelIdV103(routeId, channel.id)) {
    throw new Error('model_sync_v103.identity_error');
  }
  const config =
    typeof channel.config === 'string'
      ? JSON.parse(channel.config || '{}')
      : channel.config || {};
  if (
    !config ||
    typeof config !== 'object' ||
    Array.isArray(config) ||
    (typeof channel.models !== 'string' && !Array.isArray(channel.models))
  ) {
    throw new Error('model_sync_v103.refresh_error');
  }
  return {
    models: Array.isArray(channel.models)
      ? [...channel.models]
      : channel.models.split(',').filter(Boolean),
    state: config.model_sync_state_v103 || null,
  };
}

export function modelSyncTimeV103(value, unknown) {
  if (!value) return unknown;
  const numeric = Number(value);
  const date = new Date(
    Number.isFinite(numeric) ? numeric * (numeric < 1e12 ? 1000 : 1) : value
  );
  return Number.isNaN(date.getTime()) ? unknown : date.toLocaleString();
}
